var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar-page row-space-tbf"},[_c('div',{staticClass:"space-left"}),_c('div',{staticClass:"content"},[_c('calendar-app')],1),_c('div',{staticClass:"space-right"})])}
var staticRenderFns = []

export { render, staticRenderFns }